import { AppStrings } from '../messages';

export const SpanishLatam: AppStrings = {
    or: ' o ',
    max: 'máx.',
    accept: 'Aceptar',
    submit: 'Enviar',
    back: 'Volver',
    purchase: 'Comprar',
    no_thanks: 'No gracias',
    thank_you: '¡Gracias!',
    cancel: 'Cancelar',
    close: 'Cerrar',
    click_here_to_get_code: 'Haz click aquí para obtener el código',
    open: 'Abrir',
    option_unavailable: 'Esta opción no está disponible',
    confirm: 'Confirmar',

    my_trip: 'Mi viaje',
    finalize_trip: 'Finaliza tu viaje',
    trip_all_set: 'Tu viaje está listo',
    manage_guests_capitalized: 'Invitar a Huéspedes',
    manage_guests_title: 'Invitar a huéspedes',
    manage_pets_title: 'Agregar/Eliminar Perros',
    manage_pets_error: 'Lo siento, ocurrió un error. Para hablar con un representante de servicio al cliente, llame al 1-800-544-0300',
    add_remove_guest: 'Agregar o Quitar Huésped',
    modify_your_trip: 'Modifica tu viaje',
    instructions_for_modify_guests:
        'Haznos saber cuántos adultos y niños (mayores de 2 años) se quedarán. Si tus planes aún no finalizan, agrega los invitados que conoces por ahora; puedes regresar y actualizar esta información más tarde.',
    instructions_for_modify_guests_pets:
        'Haznos saber cuántos adultos, niños (mayores de 2 años) y perros se quedarán. Si tus planes aún no están finalizados, agrega los invitados que conoces por ahora; puedes regresar y actualizar esta información más tarde.',
    instructions_for_modify_pets: 'Amigos peludos con colas meneantes son bienvenidos. Añade hasta {pets} perros a tu estancia.',
    instructions_for_modify_pet: 'Amigo peludo con cola meneante son bienvenido. Añade 1 perro a tu estancia.',
    extra_instructions_for_modify_pet:
        '¿Cambiaste de idea? Le reembolsaremos cualquier tarifa por mascota pagada dentro de los 5 días hábiles.',
    max_occupancy_modify_guests:
        'La ocupación max. es de {max_occupancy} {guests}. Se pueden aplicar cargos adicionales y se mostrarán a continuación.',
    getting_there: 'Cómo llegar',
    in_the_home: 'En la casa',
    checkout_instructions: 'Instrucciones check-out',
    codes_will_be_provided: 'Te proporcionaremos los códigos 1 semana antes de la fecha de check-in',
    passwords_will_be_provided: 'Te proporcionaremos las contraseñas 1 semana antes de la fecha de check-in',
    alarm_code: 'Código de la alarma',
    lockbox_code: 'Código de la caja de seguridad para llaves',
    e_lock_codes: 'Códigos de E-Lock',
    gate_access: 'Puerta de acceso',
    stay_longer: 'Quédate un poco más',
    location_and_parking: 'Ubicación y estacionamiento',
    on_your_way: 'En tu camino',
    directions_to_know: 'Direcciones a saber',
    directions_and_parking_notes: 'Direcciones y estacionamiento',
    parking_spaces: 'Espacios de estacionamiento',
    parking_notes: 'Notas de estacionamiento',
    entering_home: 'Ingreso a la casa',
    home_access_details: 'Información de acceso a la casa',
    house_rules: 'Reglas de la casa',
    internet_access: 'Acceso a Internet',
    network: 'Red',
    password: 'Contraseña',

    reservation: 'Reserva',
    trip_overview: 'Resumen del viaje',
    nights: 'Noches',
    max_occupancy: 'Capacidad máxima',
    can_add_guest: 'Puedes agregar hasta {total} {guests} más',
    can_not_add_guest: 'Has alcanzado el número máximo de invitados',
    guest: 'Huésped',
    guests: 'Huéspedes',
    confirmation: 'Confirmación',
    view_listing: 'Ver la publicación',

    print_booked_by: 'Reservado por',
    print_on: 'en',
    print_header_text: 'Por favor, siga estas instrucciones. Se le notificará una vez que hayamos recibido y procesado su acuerdo',
    print_step_one: 'Imprima, revise y firme este acuerdo',
    print_step_two: 'Envíenoslo por correo electrónico o fax',
    print_button: 'Imprimir',
    print_email_label: 'Email',
    print_fax_label: 'Fax',
    print_email_value: 'info@vacasa.com',
    print_fax_value: '(503) 897-7036',
    rental_agreement: 'Contrato de alquiler',
    sign_agreement: 'Firma el contrato',
    sign_by: 'Revisa y firma hasta el {signBy}',
    sign_agreement_by: 'Firma la información de tu contrato de alquiler hasta el {signBy}',
    signed_on: 'Firmado el {signedOn}',
    i_agree_terms: 'Acepto los términos y condiciones anteriormente establecidos',
    agreed_on: 'Has aceptado estos términos y condiciones el {agreedOn}',
    i_agree_new_terms: `Acepto el <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contrato de Alquiler</a> de Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Política de Privacidad</a>, y `,
    agreed_new_terms_on: `Usted aceptó el <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contrato de Alquiler</a> de Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Política de Privacidad</a>, y `,
    agreed_new_terms_on_date: ` el {date}`,
    unit_terms_text: `Términos Específicos de la Unidad`,
    unit_terms_alert: `A menos que se indique lo contrario en `,
    new_terms_required_text: `Requerido`,
    new_terms_instructions_text: `Revisa las reglas de la casa y confirma el acuerdo debajo`,
    new_terms_submit_btn: 'Enviar',
    view_agreement: 'Ver el contrato',
    payment_details: 'Información sobre el pago',
    make_payment: 'Realiza un pago',
    pay_balance: 'Pagar Saldo',
    balance_due: 'Saldo restante',
    payment_complete: 'Pago realizado',
    pay_by: '{total} con vencimiento en {payBy}',
    pay_balance_by: 'Paga tu saldo antes del {payBy}',
    view_receipt: 'Ver el recibo',

    refund_going_to: 'El reembolso se hará a',
    original_payment_methods: 'Método(s) de pago original',
    guest_paid: 'Huésped pagó ${amount} el {date}',
    refund_details: 'Detalles del reembolso',
    total_refund: 'Reembolso Total',
    original_payment: 'Pago Original',

    cancellation_charges: 'Cargos por Cancelación',
    sure_you_want_to_cancel: '¿Estás seguro que deseas cancelar tu viaje?',
    yes_cancel_now: 'Sí, Cancelar Ahora.',
    no_dont_cancel: 'No, No Quiero Cancelar.',
    cancel_trip: 'Cancelar Viaje',
    cancel_and_receive_refund: 'Cancelar y Recibir Reembolso',
    view_cancellation_policy: 'Ver Política de Cancelación',

    balance_in: 'Saldo en {currency}',
    total_in: 'Total en {currency}',
    new_balance_due: 'Nuevo saldo en {currency}',
    processed_in_currency_notice: 'Ten en cuenta que esta transacción se procesó en {currency}. El tipo de cambio es aproximado.',

    vehicle_registration: 'Registro de Vehículo',
    vehicle: 'Vehículo',
    list_your_vehicles: 'Los vehículos de tu grupo',
    register_vehicle: 'Registra los vehículos',
    max_vehicles_reached: 'Alcanzaste el máximo de vehículos',
    group_has_no_vehicles: 'Mi grupo no tiene vehículos',
    register_by: 'Agrega todos los vehículos antes del {registerBy}',
    register_vehicles_by: 'Registra tus vehículos hasta el {registerBy}',
    add_vehicle_info: 'Añade la información del vehículo',
    add_a_vehicle_button: 'Añadir vehículo',
    add_vehicle_title: 'Añade un vehículo',
    add_vehicle_text: 'Añade un vehículo a tu viaje',
    vehicle_added: 'Información del vehículo añadida',
    edit_a_vehicle_button: 'Guardar Cambios',
    edit_vehicle_title: 'Edita un vehículo',
    edit_vehicle_text: 'Edita la información de tu vehículo.',
    remove_vehicle_text: 'Elimina un vehículo de tu viaje',
    remove_vehicle_title: 'Elimina un vehículo',
    remove_vehicle_button: 'Eliminar',
    my_group_has_no_vehicles_title: 'Mi grupo no tiene vehículos',
    my_group_has_no_vehicles_confirm_text:
        'Puedes ser multado por la ciudad o por HOA si tu grupo trae un vehículo sin registrarlo con anticipación.',
    my_group_has_no_vehicles_confirm_button: 'Confirmar sin Vehículos',
    license_plate: 'Placa del vehículo',
    state_province: 'Estado / provincia',
    other: 'Otro',
    location: 'Ubicación',

    add_on: 'Extras',
    pool_heat: 'Climatización de piscina',
    pool_heat_added: 'Climatización de piscina añadida',
    pool_heat_note: '¡Mejora tu estancia con nuestra opción de climatización de piscina! Sumérgete en comodidad y calor en cada nadada.',

    finalize_your_reservation: 'Finaliza tu reserva',
    these_actions_are_required: 'Debes realizar las siguientes acciones para obtener los detalles de tu check-in.',

    need_help: '¿Necesitas ayuda?',
    visit_our: 'Visita nuestra',
    support_center: 'Centro de Apoyo',
    still_have_questions: '¿Aún tienes preguntas?',
    please_reach: 'ponte en contacto: ',

    home_essentials: 'Artículos esenciales de la casa',
    no_beds: 'Sin camas',
    king_bed: 'cama king',
    king_bed_plural: 'camas king',
    queen_bed: 'cama queen',
    queen_bed_plural: 'camas queen',
    double_bed: 'cama de dos plazas',
    double_bed_plural: 'camas de dos plazas',
    twin_bed: 'cama individual',
    twin_bed_plural: 'camas individuales',
    child_bed: 'cama infantil',
    child_bed_plural: 'camas infantiles',
    murphy_bed: 'cama plegable',
    murphy_bed_plural: 'camas plegables',

    no_bathrooms: 'Cantidad de baños',
    full_bath: 'baño completo',
    full_bath_plural: 'baños completos',
    half_bath: 'medio baño',
    half_bath_plural: 'medios baños',

    sleeps: 'Duermen',

    loading: 'Cargando',
    updated_successfully: 'Actualización exitosa',
    read_more: '...Más información',
    read_less: '...Menos información',

    who_is_coming: 'Quienes vienen',
    invite_guest: 'Invitar huésped',
    invite_guest_note:
        'Los huéspedes invitados recibirán un correo electrónico con información detallada sobre el check-in {daysBefore} antes del viaje.',
    invite_guest_note_same_day:
        'Los huéspedes invitados recibirán un correo electrónico con información sobre el check-in el día de llegada.',
    add_guest: 'Invitar huésped',
    edit_guest: 'Editar huésped',
    remove_guest: 'Eliminar huésped',
    edit_guest_note_modal: 'Edita tus huéspedes para compartir el itinerario y la información de acceso para este viaje.',
    invite_guest_info: 'Añade información sobre los huéspedes',
    email_addresses_guests: 'Dirección de correo electrónico',
    modify_guest_note: 'Puedes añadir o eliminar huéspedes de tu viaje.',
    modify_guest_add_note: 'Puedes añadir hasta {remainingGuests} huéspedes más',
    need_cancel_trip: '¿Necesitas cancelar tu viaje?',
    need_cancel_note: 'Si necesitas cancelar tu viaje, lee las condiciones aquí.',
    cancel_trip_options: 'Ver opciones de cancelación',
    name: 'Nombre',
    first_name: 'Nombre',
    last_name: 'Apellido',
    email_address: 'Dirección de correo electrónico',
    invite_guest_note_modal: 'Añade tus huéspedes para compartir el itinerario y la información de acceso para este viaje.',
    yes_remove_invited: 'Sí',
    no_remove_invited: 'No importa',
    can_add_pet: 'Agregar hasta {total} amigo peludo',
    can_add_pets: 'Agregar hasta {total} amigos peludos',
    can_not_add_pet: 'Has alcanzado el número máximo de perros',
    add_pet_refund_btn: 'Recibir reembolso',
    add_pet_update_balance_title: 'Actualizar Saldo',
    add_pet_checkout_title: 'Continuar para pagar',
    pet: 'Perro',
    pets: 'Perros',
    remove_invite_note: 'será eliminado del listado de huéspedes',
    are_you_sure: '¿Estás seguro?',
    read_cookie_policy: 'Lee nuestra Política de Cookies',
    cookie_disclaimer: 'Vacasa utiliza cookies propios y de terceros. Al utilizar nuestros sitios, aceptas nuestra Política de Cookies.',

    sitemap: 'Mapa del sitio',
    privacy: 'Privacidad',
    terms_of_service: 'Términos y condiciones de servicio',

    property_management: 'Gestión de Alquileres Vacacionales',
    real_estate: 'Gestión Inmobiliaria',
    innovation: 'Innovación',
    company: 'Empresa',
    about_us: 'Acerca de Nosotros',
    careers: 'Desarrollo Profesional',
    newsroom: 'Sala de Prensa',
    investors: 'Inversores',
    community: 'Comunidad',
    social_responsibility: 'Responsabilidad Social',
    leadership: 'Liderazgo',
    blog: 'Blog',
    solutions_partnerships: 'Soluciones y Alianzas',
    accessibility: 'Accesibilidad',
    help: 'Ayuda',
    support_contact: 'Soporte y Contacto',
    toll_free: 'Tel. Gratuito:',
    local: 'Local:',
    covid_update: 'Actualizaciones de COVID-19',
    hi: 'Hola, ',
    my_trips: 'Mis Viajes',
    favorites: 'Favoritos',
    profile: 'Perfil',
    logout: 'Cerrar Sesión',
    owner_login: 'Ingreso de Propietario',
    owner_portal: 'Cuenta de Propietario',
    login: 'Ingreso / Registro de Huésped',
    find_my_trip: 'Encontrar Mi Viaje',
    my_account: 'Iniciar sesión / Registrarse',
    language_and_currency: 'Idioma',
    somethings_not_right: 'Hubo algún problema',
    an_error_occurred: 'Hubo un error al procesar tu solicitud',
    try_later_or_call: 'Vuelve a intentarlo más tarde o llama a tu representante de Vacasa al',

    something_went_wrong: 'Oh no, algo salió mal',
    error_cancelling: 'Ocurrió un error al cancelar su reserva.',
    contact_customer_service: 'Comuníquese con nuestro servicio de atención al {phone} para obtener más ayuda',

    identity_check_required: 'Debes verificar tu identidad para continuar',
    verify_identity: 'Verifica tu identidad',

    already_completed_idv: '¿Ya la completaste?',
    click_here: 'Haz click aquí',

    guest_portal_unavailable: 'Trip Manager no está disponible',
    resolve_issues_calling: 'Para resolver este inconveniente, llama a tu representante de Vacasa al',

    session_expired: 'Sesión caducada',
    session_expired_message: 'La sesión ha caducado. Serás redirigido a',

    access_token_expired: 'Sesión caducada',
    access_token_expired_message: 'La sesión ha caducado. Serás redirigido a renovar tu sesión.',

    trip_overview_capitalized: 'Resumen del Viaje',
    getting_there_capitalized: 'Cómo llegar',

    modify_your_trip_capitalized: 'Modifica tu viaje',
    checkout_instructions_capitalized: 'Instrucciones Check-out',
    view_receipt_capitalized: 'Ver Recibo',

    trip_eligibility_trip_already_started:
        '¡Hurra, tu viaje ha comenzado! Si aún necesitas modificar tu viaje, ponte en contacto con un representante de atención al huésped de Vacasa llamando al',
    trip_eligibility_pending_payment: 'Tu pago está siendo procesado. Vuelve a ingresar en 24 horas para modificar tu viaje.',
    trip_eligibility_created_before_june_fourth_2018:
        'Si aún necesitas modificar tu viaje, ponte en contacto con un representante de atención al huésped de Vacasa llamando al',
    trip_eligibility_negative_balance: 'Tu reembolso está siendo procesado. Vuelve a ingresar en 24 horas para modificar tu viaje.',
    trip_eligibility_not_allowed_for_occupancy: 'Lo sentimos, no puedes modificar huéspedes/mascotas en esta reserva.',
    trip_eligibility_refund_in_progress: 'Tienes un reembolso en curso. Por favor espera hasta que se procese para modificar tu ocupación',

    wheres_my_receipt: '¿Dónde está el comprobante de mi reserva?',
    channel_receipt_note:
        'Hicistes tu reserva a través de uno de nuestros socios de reservas. Por favor, comunícate con la empresa con la que reservaste para obtener su recibo e información de pago.',

    download_app_mobile_note: 'Detalles del viaje, información de check-in y más.',
    download_app_mobile_title: 'Consígalo todo en la app',

    payment_title: 'Realizar un pago',
    receipt_title: 'Recibo',
    addons_title: 'Complementos de viaje',
    latecheckout_title: 'Agregar late-checkout',
    modify_trip_title: 'Modificar viaje',

    pool_heat_add_or_remove: 'Agregar o quitar Calentador de piscinas',

    submit_guest_edition: 'Enviar la edición de invitado',
    confirm_guest_remove: 'Confirmar eliminar al invitado',

    ready_to_checkout: '¿Listo para pagar?',
    note_early_checkout:
        'Haga clic para confirmar que está finalizando la compra. Esto también notificará a nuestro equipo de limpieza que te has marchado.',
    checkout_now: 'Chequear ahora',
    not_ready_yet: 'No estoy listo todavía',
    all_set: '¡Todo listo!',
    note_confirm_early_checkout: 'Gracias, su salida está completa. Esperamos volver a hospedarte pronto!',
    got_it: 'No hay problema',
    note_cancel_early_cehckout:
        'Puede pagar antes de las {checkout}. Cuando esté listo, haga clic en el enlace de pago nuevamente en el mensaje de texto que le enviamos.',

    rent: 'Renta',
    fees: 'Tarifas',
    taxes: 'Impuestos',
    trip_protection: 'Seguro de Viaje',
    not_purchased: 'No Comprado',
    previous_balance: 'Balance anterior',
    sub_total: 'Sub-total',
    pet_refund: 'Reembolso por perro',
    adult_added: 'Adulto añadido',
    adults_added: 'Adultos añadidos',
    pet_added: 'Perro añadido',
    pets_added: 'Perros añadidos',
    child_added: 'Niño añadido',
    children_added: 'Niños añadidos',

    payment_processed_by: 'Pago procesado por:',
    billing_address: 'Dirección de Envio:',

    receipt_thirty_party_channel: 'Gracias por reservar su casa Vacasa a través de {channel}',

    covid19_text: 'Actualización del coronavirus (COVID-19) y nuestras políticas de cancelación',
    covid19_button_text: 'Ver actualizaciones',
    covid19_link: 'https://www.vacasa.com/support/coronavirus-covid-19',

    square_feet: 'pies cuadrados',

    browser_deprecated: 'Navegador no soportado',
    please_upgrade_browser: 'Por favor, actualice o use otro navegador para ver este sitio',

    know_before_you_go: 'Qué debe saber antes de ir',
    import_details: 'Detalles importantes',
    directions_and_parking_details: 'Direcciones y detalles de estacionamiento',
    note_for_our_guests: 'Notas para nuestros invitados',

    cannot_perform_action_title: 'Está página no está disponible',
    cannot_perform_action_message: 'Vuelve a intentarlo más tarde o llama a tu representante de Vacasa al',

    fsc_credits: 'Future Stay Credits',

    address: 'Dirección',
    features_and_amenities: 'Características y comodidades',
    features_and_amenities_capitalized: 'Características y Comodidades',

    cancel_trip_title: 'Cancelar su Viaje',

    payment_form_add_night: 'Agrega una noche',
    payment_form_add_night_note: 'Su nueva hora de check-out será',
    payment_form_pricing_details: 'Detalle de precios',
    payment_form_pricing_discounted_rent: 'Renta con descuento',
    payment_form_pricing_discount: 'Descuento',
    payment_form_total: 'Total',
    payment_form_billing_information: 'Datos de facturación',
    payment_form_billing_name: 'Nombre de facturación',
    payment_form_country: 'País',
    payment_form_city: 'Ciudad',
    payment_form_state: 'Estado',
    payment_form_island: 'Isla',
    payment_form_province: 'Provincia',
    payment_form_department: 'Departamento',
    payment_form_postal_code: 'Código Postal',
    payment_form_zip_code: 'Código Postal',
    payment_form_city_or_town: 'Ciudad/Pueblo',
    payment_form_region: 'Región',
    payment_form_county: 'Condado',
    payment_form_area: 'Área',
    payment_form_parish: 'Parroquia',
    payment_form_prefecture: 'Prefectura',
    payment_form_emirate: 'Emirato',
    payment_form_governorate: 'Gobernación',
    payment_form_card_number: 'Número de Tarjeta',
    payment_form_expiration_date: 'Fecha de caducidad',
    payment_form_expiration_month: 'Mes de expiración',
    payment_form_expiration_year: 'Año de expiración',
    payment_form_security_code: 'Código de seguridad',
    payment_form_payments_note: 'Aceptamos la mayoría de las tarjetas de crédito',
    payment_form_pay_now: 'Pagar Ahora',
    payment_form_visa: 'Visa',
    payment_form_master_card: 'Master',
    payment_form_discover: 'Discover',
    payment_form_reservation_details: 'Detalles de la reserva',
    payment_form_adult: 'Adulto',
    payment_form_adults: 'Adultos',
    payment_form_child: 'Niño',
    payment_form_children: 'Niños',
    payment_form_month: 'Mes',
    payment_form_year: 'Año',
    payment_successful: '¡Todo listo!',
    payment_successful_note:
        'Disfruta esa noche extra de vacaciones. A continuación, encontrará los detalles de su pago y revise su bandeja de entrada para obtener un correo electrónico de confirmación con las nuevas fechas de su viaje.',
    payment_failed: 'Nosotros no pudimos procesar su pago',
    payment_call_us_to_complete: 'No se preocupe, por ahora, estamos reservando la noche extra para usted.',
    payment_call_us_to_complete_start: 'Llame a',
    payment_call_us_to_complete_end: 'para pagar por teléfono y confirmar el cambio en su viaje.',
    payment_form_removed: 'Eliminado',
    payment_form_added: 'Añadido',
    payment_successful_generic_note: 'Tu viaje está actualizado. Aquí está tu confirmación de pago.',
    payment_trip_paid_in_full: 'Tu viaje está pagado en su totalidad.',
    payment_successful_add_pet_adjustment_note:
        'Añadiste {total} {pet} a tu viaje. Que comience el movimiento de colas. Aquí tienes la confirmación de pago.',
    payment_successful_add_pet_adjustment_refund_note:
        'Eliminaste {total} {pet} de tu viaje. Te reembolsaremos cualquier tarifa por mascota pagada en un plazo de 5 días hábiles.',
    payment_successful_add_pool_heat_adjustment_note:
        'Has añadido calefacción de piscina a tu estancia. Aquí tienes la confirmación de tu pago.',

    modal_adjustment_not_available_continue: 'Continuar',
    modal_adjustment_not_available_back_to_trip: 'Volver a Detalles del viaje',
    modal_adjustment_not_available_title: 'Esta noche ya no está disponible',
    modal_adjustment_not_available_note_start:
        'Lo sentimos, no podemos agregar la noche adicional a su viaje. (Otro huésped ya lo reservó o la oferta ya venció).',
    modal_adjustment_not_available_note_end: '¡Esperamos que tenga una excelente estadía!',

    modal_adjustment_pending_balance_title: 'Paga tu saldo para desbloquear esta oferta',
    modal_adjustment_pending_balance_note_start: 'Antes de agregar una noche, deberá pagar el saldo actual de su viaje.',
    modal_adjustment_pending_balance_note_end: 'Una vez que haya pagado, puede volver a su correo electrónico e intentarlo de nuevo.',

    modal_lco_adjustment_not_available_title: 'Check-out tardío no disponible',
    modal_lco_adjustment_not_available_note_start: 'Lo sentimos, no podemos añadir la salida tardía a tu estancia.',
    modal_lco_adjustment_pending_balance_note_start: 'Antes de agregar la salida tardía, deberás pagar el saldo actual de tu viaje.',

    night_added: 'noche agregada',
    nights_added: 'noches agregadas',

    maintenance_window_title: 'Esta página está en mantenimiento',
    maintenance_window_note: 'Estaremos en vivo de nuevo muy pronto. Gracias por tu paciencia.',
    maintenance_go_to_home: 'Ir a la página de inicio',
    maintenance_link: 'https://www.vacasa.com',

    modal_cancel_go_to_my_trips: 'Ir a My Trips',
    modal_cancel_title: 'Reserva cancelada',
    modal_cancel_note: 'Tu reserva ha sido cancelada con éxito',

    billing_information_note: 'Revisa tus cambios y confirma que las actualizaciones de tu viaje estén completas.',

    adjustment_failed_title: 'No hemos podido modificar tu viaje',

    whats_nearby: 'Que hay cerca',
    whats_nearby_capitalized: 'Que hay Cerca',
    checkout_best_of_city:
        'Mira lo mejor de {unitCity} mientras estás aquí. Explora restaurantes populares, atracciones y más alrededor de {unitName}.',
    banking: 'Bancaria',
    restaurants_and_coffee: 'Restaurantes y Café',
    groceries: 'Supermercados',
    hospitals: 'Hospitales',
    movie_theaters: 'Cines',
    bars_and_nightlife: 'Bares y Vida Nocturna',
    parks: 'Parques',
    pharmacies: 'Farmacias',
    shopping: 'Compras',
    sports: 'Deportes',
    universities: 'Universidades',
    tourist_attractions: 'Atracciones turísticas',
    filter_by_category: 'Filtrar por categoría',

    star_rating_title: 'Revisa tu estadía',
    star_rating_note: '¿Cómo fue tu experiencia en {unitName}? Tu feedback es importante para nosotros.',
    next: 'Siguiente',

    pay_balance_issue: 'Llama al {phone} para pagar y confirmar el cambio de tu viaje.',

    chat_default_message: 'Hola, ¿Te podemos ayudar en algo hoy?',
    chat_default_name: 'Vacasa Customer Service',
    chat_start_new_button: 'Iniciar nuevo chat',
    chat_start_content: 'Gracias por chatear con nosotros!',
    chat_open: 'El chat en vivo está disponible',
    chat_message_close:
        'Lamentablemente, te contactaste fuera del horario de chat en vivo. Para obtener asistencia inmediata, llame a nuestra línea de soporte las 24 horas.',
    chat_rule_close: '{openTime} a {closeTime}.',
    chat_rule: 'todos los días de {openTime} a {closeTime}.',
    chat_error: 'Error al inicializar el chat',
    chat_loading: 'cargando ...',
    chat_me: 'Yo',

    extended_stay_capitalized: 'Extender Mi Estadía',
    extended_stay_rules: 'Seleccione hasta 4 noches adicionales antes o después de tu viaje programado para extender su estadía.',
    extended_stay_success_alert_plural: '<b>{numberNights} noches</b> añadidas a tu itinerario por <b>{price}</b>',
    extended_stay_success_alert: '<b>1 noche</b> añadida a tu itinerario por <b>{price}</b>',
    extended_stay_error_message:
        'Lo sentimos, se produjo un error. Para hablar con un representante de servicio al cliente, llame al 1-800-544-0300',
    extended_stay_note_message: 'Sus nuevas fechas de entrada y salida serán',
    check_in: 'Check in',
    check_in_description: 'Fechas de entrada disponibles:',
    check_out: 'Check out',
    check_out_description: 'Fechas de salida disponibles:',
    empty_calendar_before_options: '* Lamentablemente todas las fechas antes de tu viaje no están disponibles.',
    empty_calendar_after_options: '* Lamentablemente todas las fechas posteriores a tu no están disponibles.',
    payment_form_add_extended_stay: '{days} Noches Adicionales',
    today: 'Hoy',
    clear: 'Limpiar',
    checkout: 'Pagar',
    reset_dates: 'Restablecer fechas',
    total_cost: 'Costo total',

    late_check_out_capitalized: 'Agrega late check-out',
    payment_form_add_late_check_out_note: 'Su nueva hora de check-out será',
    payment_form_add_late_check_out: 'Late check-out añadido',

    bedroom_title: 'Distribución de camas',
    view_all_beds: 'Ver las {total} distribuciones de camas',
    view_less: 'Ver menos',
    view_more: 'Ver más',

    pool_heat_capitalized: 'Agregar climatización de piscina',
};
